import {html, css, LitElement} from 'lit';

export class DzMiniSpoiler extends LitElement {

    static properties = {
        opened: {type: Boolean, reflect: true},
    }

    constructor() {
        super()
        this.opened = false
    }

    render() {
        return html`
            <slot name="head" @click="${this.switchState}"></slot>
            <slot name="body" style="height : ${this.opened ? 'auto' : '0px'}"></slot>
        `
    }

    switchState() {
        if (this.opened) {
            this.opened = false
        } else {
            this.opened = true
        }
    }

    static styles = css`
        slot[name=body] {
            overflow: hidden;
            display: block;
        }
    `
}

customElements.define('dz-mini-spoiler', DzMiniSpoiler)